<template>
    <div>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-1-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
        ></pagination-component>
        <table class="table simple-table table-striped table-sm mb-0 table-bordered" style="font-size:0.9em;">
            <thead class="thead-dark">
            <tr>

                <th class="report-record" scope="col">{{$lang('Biblioteka')}}</th>
                <th class="report-record" scope="col">{{$lang('Wersja')}}</th>
                <th class="report-record" scope="col">{{$lang('Aktywna')}}</th>
                <th class="report-record" scope="col">{{$lang('Wdrożenie')}}</th>
            </tr>
            </thead>
            <tbody>

            <tr v-if="pagination.total === 0" class="table-light">
                <th colspan="10">{{$lang('Brak bibliotek.')}}</th>
            </tr>

            <template v-else v-for="(library, index) in pagination.data">
                <tr>
                    <td style="text-align: left" class="report-record" :data-title="$lang('Biblioteka')">
                        <span>{{library.name}}</span>
                    </td>
                    <td class="report-record" :data-title="$lang('Wersja')">{{library.prolib_version}}</td>
                    <td class="report-record" :data-title="$lang('Aktywna')" v-if="library.active===1">
                        <span class="text-success">{{$lang('Tak')}}</span>
                    </td>
                    <td class="report-record" :data-title="$lang('Aktywna')" v-else>
                        <span class="text-danger">{{$lang('Nie')}}</span>
                    </td>
                    <td class="report-record" :data-title="$lang('Wdrożenie')" v-if="library.saas===0">
                        {{$lang('Standardowe')}}
                    </td>
                    <td class="report-record" :data-title="$lang('Wdrożenie')" v-else>
                        {{$lang('SaaS')}}
                    </td>
                </tr>
            </template>

            </tbody>
        </table>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-2-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
        ></pagination-component>
    </div>
</template>

<script>
export default {
    name: "libraries-by-version-table",
    props: {
        pagination: Object,
    }
}
</script>

<style scoped>

</style>
